<template>
  <div
    v-element-loader="{ endpoint: 'order' }"
    class="main main--history-details">
    <div class="history-details__top">
      <div class="history-details__header-wrapper">
        <h2 v-epi-edit="'orderDetailsHeader'" class="history-details__header">
          {{ t("orderDetailsHeader") }}
        </h2>
        <a
          v-if="order.orderHead.goodsInformationNo"
          target="_blank"
          rel="noopener noreferrer"
          :href="order.orderHead.goodsInformationUrl"
          class="button button-link button-link--narrow button--icon-right history-details__button-track-order">
          {{ t("trackOrder") }}
          <oie-use-svg
            svg="new-tab"
            css-classes="navigation-item__icon"></oie-use-svg>
        </a>
        <a
          v-if="orderReturnSettings.enabled"
          :href="getOrderReturnUrl(order.orderHead.orderNr)"
          class="button button-link button-link--narrow button--icon-right">
          {{ t("orderReturn") }}
          <oie-use-svg svg="new-tab" css-classes="navigation-item__icon"></oie-use-svg>
        </a>
      </div>

      <p v-epi-edit="'orderDetailsDescription'" class="history-details__text">
        {{ t("orderDetailsDescription") }}
      </p>
    </div>

    <div v-if="order" class="grid grid--three history-details__information">
      <div class="history-details__information-box">
        <h3
          v-epi-edit="'orderInformationHeader'"
          class="history-details__information-header">
          {{ t("orderInformationHeader") }}
          <!-- Ordernummer information -->
        </h3>

        <div class="history-details__information-details">
          <div class="history-details__information-details-row">
            <div
              v-epi-edit="'orderNumberLabel'"
              class="history-details__information-details-key">
              {{ t("orderNumberLabel") }}
              <!-- Ordernummer: -->
            </div>
            <div class="history-details__information-details-value">
              {{ order.orderHead.orderNr }}
              <!-- {{ $route.params.order_id }} -->
            </div>
          </div>

          <div class="history-details__information-details-row">
            <div
              v-epi-edit="'orderDateLabel'"
              class="history-details__information-details-key">
              {{ t("orderDateLabel") }}
              <!-- Beställningssatum: -->
            </div>
            <div class="history-details__information-details-value">
              {{ order.orderHead.displayOrderDate }}
            </div>
          </div>

          <!-- <div class="history-details__information-details-row">
            <div v-epi-edit="''" class="history-details__information-details-key">
              {{ t('orderStatusLabel') }}
            </div>
            <div class="history-details__information-details-value">
              {{ order.status }}
            </div>
          </div> -->

          <div class="history-details__information-details-row">
            <div
              v-epi-edit="'orderDeliveryMethodLabel'"
              class="history-details__information-details-key">
              {{ t("orderDeliveryMethodLabel") }}
              <!-- Fraktmedtod: -->
            </div>
            <div class="history-details__information-details-value">
              {{ order.orderHead.modeOfDelivery }}
            </div>
          </div>

          <!-- <div class="history-details__information-details-row">
            <div class="history-details__information-details-key">
              {{ t('') }}
              Leveransvilkor:
            </div>
            <div class="history-details__information-details-value">
              {{ orderDetails.deliveryDeal }}
            </div>
          </div> -->

          <div class="history-details__information-details-row">
            <div
              v-epi-edit="'orderPaymentMethodLabel'"
              class="history-details__information-details-key">
              {{ t("orderPaymentMethodLabel") }}
              <!-- Betalningssätt: -->
            </div>
            <div class="history-details__information-details-value">
              {{ order.orderHead.paymentTerms }}
            </div>
          </div>

          <div
            v-if="false && order.orderHead.invoices && order.orderHead.invoices.length > 0
            "
            class="history-details__information-details-row">
            <div
              v-epi-edit="'orderPaymentMethodLabel'"
              class="history-details__information-details-key">
              {{ t("downloadInvoiceLabel") }}
              <!-- Hämta faktura: -->
            </div>
            <div class="history-details__information-details-value">
              <div class="history-details-invoice__container">
                <a
                  v-for="invoice in order.orderHead.invoices"
                  :key="invoice.invoiceNumber"
                  :href="invoice.invoicePdfUrl"
                  download
                  class="history-details-invoice__number">{{ invoice.invoiceNumber }}

                  <oie-use-svg svg="download-invoice"></oie-use-svg>
                </a>
              </div>
            </div>
          </div>

          <div class="history-details__information-details-row">
            <div
              v-epi-edit="'orderCommentLabel'"
              class="history-details__information-details-key">
              {{ t("orderCommentLabel") }}
              <!-- Kommentarer: -->
            </div>
            <div class="history-details__information-details-value">
              {{ order.orderHead.comment }}
            </div>
          </div>
        </div>
      </div>

      <div class="history-details__information-box">
        <h3
          v-epi-edit="'orderDeliveryAddressHeader'"
          class="history-details__information-header">
          {{ t("orderDeliveryAddressHeader") }}
          <!-- Leveransadress -->
        </h3>

        <div class="history-details__information-address">
          <div class="history-details__information-address-row">
            {{ order.orderHead.deliveryAddress.name }}
          </div>
          <div class="history-details__information-address-row">
            {{ order.orderHead.deliveryAddress.address1 }}
            <template v-if="order.orderHead.deliveryAddress.address2">
              <br>{{ order.orderHead.deliveryAddress.address2 }}
            </template>
          </div>
          <div class="history-details__information-address-row">
            {{ order.orderHead.deliveryAddress.zipCode }}
            {{ order.orderHead.deliveryAddress.city }}
          </div>
          <div class="history-details__information-address-row">
            {{ order.orderHead.deliveryAddress.country }}
          </div>
        </div>
      </div>

      <div class="history-details__information-box">
        <h3
          v-epi-edit="'orderInvoiceAddressHeader'"
          class="history-details__information-header">
          {{ t("orderInvoiceAddressHeader") }}
          <!-- Fakturaadress -->
        </h3>

        <div class="history-details__information-address">
          <div class="history-details__information-address-row">
            {{ order.orderHead.invoiceAddress.name }}
          </div>
          <div class="history-details__information-address-row">
            {{ order.orderHead.invoiceAddress.address1 }}
            <template v-if="order.orderHead.invoiceAddress.address2">
              <br>{{ order.orderHead.invoiceAddress.address2 }}
            </template>
          </div>
          <div class="history-details__information-address-row">
            {{ order.orderHead.invoiceAddress.zipCode }}
            {{ order.orderHead.invoiceAddress.city }}
          </div>
          <div class="history-details__information-address-row">
            {{ order.orderHead.invoiceAddress.country }}
          </div>
        </div>
      </div>
    </div>

    <div class="history-details-products">
      <div v-epi-edit="'orderRowsHeader'" class="history-details-products__top">
        {{ t("orderRowsHeader") }}
      </div>

      <oie-order-history-details-product-table
        :rows="order.orderRows"
        class="history-details-products__table"></oie-order-history-details-product-table>

      <div class="history-details-products__summary">
        <div
          v-epi-edit="'orderAmountExcludedVatLabel'"
          class="history-details-products__summary-row">
          <!-- Betalningt exklusive moms -->
          {{ t("orderAmountExcludedVatLabel") }}
          <div class="history-details-products__summary-value">
            {{ formatPrice(order.orderHead.orderSum) }}
          </div>
        </div>

        <div
          v-epi-edit="'deliveryCostExcludedVatLabel'"
          class="history-details-products__summary-row">
          {{ t("deliveryCostExcludedVatLabel") }}
          <!-- Fraktkostnad exklusive moms -->
          <div class="history-details-products__summary-value">
            {{ formatPrice(order.orderHead.shipmentCost) }}
          </div>
        </div>

        <div
          v-if="order.orderHead.packagingCost > 0"
          v-epi-edit="'packagingCostExcludedVatLabel'"
          class="history-details-products__summary-row">
          {{ t("packagingCostExcludedVatLabel") }}
          <!-- Fraktkostnad exklusive moms -->
          <div class="history-details-products__summary-value">
            {{ formatPrice(order.orderHead.packagingCost) }}
          </div>
        </div>

        <div
          v-epi-edit="'vatLabel'"
          class="history-details-products__summary-row">
          {{ t("vatLabel") }}
          <!-- Moms -->
          <div class="history-details-products__summary-value">
            {{ formatPrice(order.orderHead.vatSum) }}
          </div>
        </div>

        <div
          v-epi-edit="'orderTotalAmountLabel'"
          class="history-details-products__summary-row">
          {{ t("orderTotalAmountLabel") }}
          <!-- Totalt (inklusive frakt och betalningsavgift) -->
          <div
            class="history-details-products__summary-value history-details-products__summary-value--larger">
            {{ formatPrice(order.totalSum) }}
          </div>
        </div>
      </div>

      <oie-base-button
        v-tooltip.top="{
          content: tStatic('itemsHaveBeenAddedToCart'),
          trigger: 'click',
          autoHide: true
        }"
        v-epi-edit="'addToCartButtonLabel'"
        :text="t('addToCartButtonLabel')"
        :disabled="selectedHistoryRows.length === 0"
        css-classes="button--with-border button--green"
        @click="addToCart"></oie-base-button>
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  props: {
    orderNumber: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    orderReturnSettings: {
      enabled: false
    },
    selectedHistoryRows: [],
    order: {
      orderHead: {
        orderNr: '',
        orderDate: '',
        displayOrderDate: '',
        customerNo: '',
        currency: '',
        paymentTerms: '',
        modeOfDelivery: '',
        shipmentId: '',
        ourRef: '',
        invoiceRefernce: '',
        shipmentCost: 0,
        packagingCost: 0,
        vatSum: 0,
        orderSum: 0,
        comment: '',
        goodsInformationNo: '',
        goodsInformationUrl: '',
        deliveryAddress: {
          name: '',
          address1: '',
          address2: '',
          zipCode: '',
          city: '',
          country: ''
        },
        invoiceAddress: {
          name: '',
          address1: '',
          address2: '',
          zipCode: '',
          city: '',
          country: ''
        }
      },
      orderRows: []
    }
  }),
  watch: {
    orderNumber(newId) {
      httpService
        .get(`order/${this.orderNumber}`, { orderNumber: this.orderNumber })
        .then(response => {
          this.order = response.data
        })
    }
  },
  mounted() {
    if (this.orderNumber !== '') {
      httpService
        .get(`order/${this.orderNumber}`, { orderNumber: this.orderNumber })
        .then(response => {
          this.order = response.data
        })
    }

    this.subscribe('order-history-rows-selection-updated', rows => {
      this.selectedHistoryRows = rows
    })

    httpService
      .get(`order-return/settings`, {})
      .then(response => {
        this.orderReturnSettings = response.data
      })
  },
  methods: {
    addToCart() {
      const payload = _.map(this.selectedHistoryRows, item => {
        return { itemId: item.artNr, quantity: item.quantity }
      })
      this.$store.dispatch('commerce/addListToCart', { rows: payload })
    },
    getOrderReturnUrl(orderNumber) {
      if (!this.orderReturnSettings.useCustomerOrderReturnPage) {
        return `${this.clientModel.orderReturnUrl}?orderNumber=${orderNumber}`
      } else {
        return `${this.clientModel.customerOrderReturnUrl}?orderNumber=${orderNumber}`
      }
    }
  }
}
</script>

<style lang="scss">
.main--history-details {
  @include container;
  padding-top: measure(double);
  padding-bottom: measure(double);
}

.history-details__top {
  margin-bottom: measure(double);
}
.history-details__header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.history-details__information {
  margin-bottom: measure(half);
}

.history-details__phone-link {
  margin-top: measure(quarter);
  color: color(text-blue);
}

.history-details__information-box {
  @include body-smaller;
  background-color: color(background-white);
  border: 1px solid color(border-gray);
  padding: measure(half);
}

.history-details__information-header {
  @include h3-semi-bold;
  margin-top: 0;
}

.history-details__information-details-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: measure(eighth);
}

.history-details__information-details-key,
.history-details__information-details-value {
  flex-basis: 50%;
}

.history-details__information-address-row {
  margin-bottom: measure(eighth);
}

.history-details-products__top {
  @include body-semi-bold;
  display: flex;
  align-items: center;
  padding: measure(quarter) 0;
}

.history-details-products__table {
  margin-bottom: measure(half);
}

.history-details-products__summary {
  @include body-smaller;
  background-color: color(background-white);
  border: 1px solid color(border-gray);
  margin-bottom: measure(half);
  padding: measure(half);

  @include media(medium) {
    @include body;
  }
}

.history-details-products__summary-row {
  display: flex;
  flex-direction: column;
  margin-bottom: measure(half);

  &:last-child {
    margin-bottom: 0;
  }

  @include media(medium) {
    flex-direction: row;
    margin-bottom: measure(quarter);
  }
}

.history-details-products__summary-value {
  @include body-smaller-semi-bold;
  margin-left: 0;
  padding-top: measure(quarter);

  @include media(medium) {
    @include body-smaller-semi-bold;
    margin-left: auto;
    padding-top: 0;
  }
}

.history-details-products__summary-value--larger {
  @include body-semi-bold;

  @include media(medium) {
    @include h3-semi-bold;
  }
}

.history-details-invoice__container > * {
  vertical-align: middle;
  display: inline;
}

.history-details-invoice__number {
  @include reset-link;
  display: flex;
  align-items: center;
  margin-right: measure(quarter);

  & > svg {
    width: 1.4rem;
    height: 1.4rem;
    margin-left: measure(quarter);
  }
}

.history-details__button-track-order {
  margin-right: 1rem;
  margin-left: auto;
}
</style>
